import { Col, TextLabel } from "../lib";
import { createStyles } from "../theme";

type Props = {
  label: string;
  variant?: "default" | "success" | "warning";
};

export function Tag({ label, variant = "default" }: Props) {
  return (
    <Col.C style={[$.container, $[variant]]}>
      <TextLabel em center color="onSurface">
        {label.toUpperCase()}
      </TextLabel>
    </Col.C>
  );
}

const $ = createStyles({
  container: {
    p: "2",
    borderRadius: 5,
  },
  default: {
    backgroundColor: "chatPrimary",
  },
  success: {
    backgroundColor: "success",
  },
  warning: {
    backgroundColor: "warning",
  },
});
